import { colors } from "@mui/material";
import StatusChip from "./StatusChip";
import { useTranslation } from "react-i18next";
import { PaymentStatus } from "Domain/Payment/Entity/Payment";

type PaymentStatusProps = {
  status: PaymentStatus;
};

const statusColors: Record<PaymentStatus, string> = {
  TO_PAY: colors.deepPurple[500],
  PAYED: colors.green[800],
};

export default function PaymentStatusChip({ status }: PaymentStatusProps) {
  const { t } = useTranslation();
  const statusColor = status in statusColors ? statusColors[status] : "white";

  return (
    <StatusChip
      color={statusColor}
      label={t(`STATUS.LABEL.payment.${status}`)}
      info={t(`STATUS.INFO.payment.${status}`)}
    />
  );
}
